<template>
    <div>
        <app-form v-if="!loading"
            v-bind:parentObject = "{
                data: this.formData,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                staffList: this.staffList,
                errMsg: this.errMsg,
                isEdit: this.editMode
            }"
        />
        <div v-if="isErr">
            <app-error 
                v-bind:parentError ="{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
            />
        </div>    
    </div>
</template>

<script>
import moment from 'moment';
import ReviewSettingForm from '../../../components/performance/reviewexercise/FormSetting_Staff';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'app-form': ReviewSettingForm,
        'app-error': ErrorDialog
    },

    data() {
        return{
            pageTitle: this.$t('pmreviewexercise.appraisalrecordsfor'),
            pageTitleValue: this.$route.params.item.reviewcode,

            formData: {
                pmreviewexerciseid: this.$route.params.id,
                pmrankmapsetid : this.$route.params.item.pmrankmapsetid,
                reviewcode: this.$route.params.item.reviewcode,
                description: this.$route.params.item.description,
                assessmentcode: this.$route.params.item.assessmenttext || this.$route.params.item.assessmentcode,
                type : this.$route.params.item.formtypetext || this.$route.params.item.type || this.$route.params.item.formtype,
                startdate: this.$route.params.item.startdate,
                enddate: this.$route.params.item.enddate,
                initiated: this.$route.params.item.initiated,
                ongoing: this.$route.params.item.ongoing,
                completed: this.$route.params.item.completed,
                method : this.$route.params.item.method,
                stamp: 0,
                userid: this.$store.getters.userId,
                totalRecords: this.$route.params.item.totalRecords,
                status: this.$route.params.item.status,
                isInitiateWorkflow: this.$route.params.item.isInitiateWorkflow
            },

            staffList: [],

            loading: true,
            errMsg: '',
            isErr: false,
            editMode: false 
        }
    },
        

    methods: {
        async loadGenerateStaff() {
            const vm = this;

            // Dispatch the post request with the payloads object
            await this.$store.dispatch('get', {url: "/reviewexercise/staff/" + this.$route.params.id})
            .then((res) => {
            if (res.status == 200) {
                for (let i = 0; i < res.data.rec.length; i++) {
                    if (res.data.rec[i].startdate) {
                        res.data.rec[i].startdate = moment(res.data.rec[i].startdate).format('YYYY-MM-DD');
                    }
                    if (res.data.rec[i].enddate) {
                        res.data.rec[i].enddate = moment(res.data.rec[i].enddate).format('YYYY-MM-DD');
                    }

                    if (res.data.rec[i].statusid === 4) {
                        res.data.rec[i].statuscode = "INITIATED";
                    } else if (res.data.rec[i].statusid === 5) {
                        res.data.rec[i].statuscode = "ONGOING";
                    } else if (res.data.rec[i].statusid === 6) {
                        res.data.rec[i].statuscode = "COMPLETED";
                    }
                }
                vm.staffList = res.data.rec;
                vm.loading = !vm.loading;
            } else {
                vm.isErr = !vm.isErr;
            }
            })
            .catch((err) => {
                console.log(err);
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });

        },
        
    },

    mounted() {
    },

    async created() {
        await this.loadGenerateStaff();
    }
}

</script>